var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mv-h-full d-flex flex-column align-center justify-center"},[(_vm.isGenerated)?_c('div',[_c('v-img',{attrs:{"src":_vm.imageUrl}})],1):_c('div',{staticClass:"output-container"},[_c('p',{staticClass:"text-h6 grey--text text--darken-1"},[_vm._v("还未生成图片")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }